import { Link } from 'react-router-dom';
import type { Article } from '@/mocks/articles';

interface HotTopicsProps {
  articles: Article[];
}

export default function HotTopics({ articles }: HotTopicsProps) {
  return (
    <aside className="bg-background-50 border border-background-200/70 rounded-lg p-5" aria-label="热门话题">
      <div className="flex items-center gap-2 mb-4">
        <div className="w-8 h-8 flex items-center justify-center bg-accent-100 rounded-full">
          <i className="ri-fire-line text-accent-500 w-4 h-4 flex items-center justify-center"></i>
        </div>
        <h3 className="font-heading text-lg text-foreground-950">热门话题</h3>
      </div>
      <ol className="space-y-1">
        {articles.slice(0, 8).map((article, index) => (
          <li key={article.id}>
            <Link
              to={`/article/${article.id}`}
              className="flex items-start gap-3 py-2.5 px-2 rounded-md hover:bg-background-100 transition-colors group cursor-pointer"
            >
              <span
                className={`shrink-0 w-6 h-6 flex items-center justify-center rounded-full text-xs font-bold ${
                  index < 3
                    ? 'bg-primary-500 text-white'
                    : 'bg-background-200 text-foreground-600'
                }`}
              >
                {index + 1}
              </span>
              <span className="text-sm text-foreground-800 group-hover:text-primary-500 transition-colors line-clamp-2 leading-snug">
                {article.title}
              </span>
            </Link>
          </li>
        ))}
      </ol>
    </aside>
  );
}